import playerImg from '../images/players/player.png'
export const players = [
	{
		id: 1,
		image: playerImg,
		title: 'Poposha',
		current: '$ 300.8',
		bonus: '1.23 X',
		sum: '$ 350.00',
	},
	{
		id: 2,
		image: playerImg,
		title: 'Poposha',
		current: '$ 300.8',
	},
	{
		id: 3,
		image: playerImg,
		title: 'Poposha',
		current: '$ 300.8',
	},
	{
		id: 4,
		image: playerImg,
		title: 'Poposha',
		current: '$ 300.8',
	},
	{
		id: 5,
		image: playerImg,
		title: 'Poposha',
		current: '$ 300.8',
	},
	{
		id: 6,
		image: playerImg,
		title: 'Poposha',
		current: '$ 300.8',
	},
	{
		id: 7,
		image: playerImg,
		title: 'Poposha',
		current: '$ 300.8',
	},
	{
		id: 8,
		image: playerImg,
		title: 'Poposha',
		current: '$ 300.8',
	},
]
export const xBonus = [
	{
		title: '4.39 X',
		color: '#3CC48C',
	},
	{
		title: '4.39 X',
		color: '#812CC9',
	},
	{
		title: '4.39 X',
		color: '#258EEF',
	},
	{
		title: '4.39 X',
		color: '#192A30',
	},
	{
		title: '4.39 X',
		color: '#3CC48C',
	},
	{
		title: '4.39 X',
		color: '#812CC9',
	},
	{
		title: '4.39 X',
		color: '#258EEF',
	},
	{
		title: '4.39 X',
		color: '#DD8A4C',
	},
	{
		title: '4.39 X',
		color: '#192A30',
	},
]
